import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

interface ArchivalRow {
  readonly archivalId: string;
  readonly entityType: string;
  readonly entityReference: string;
  readonly status: string;
  readonly recordCount: number;
}

export function M19ArchivalDashboardPage(): ReactNode {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [rows, setRows] = useState<ArchivalRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ data: ArchivalRow[] }>('/v1/platform/archival', { token })
      .then((r) => { if (alive) setRows(r.data); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('m19.archival.loading')}</p>;
  return (
    <main aria-label="archival-dashboard">
      <h1>{t('m19.archival.title')}</h1>
      <table aria-label="archival-table">
        <thead><tr><th>{t('m19.archival.colEntityType')}</th><th>{t('m19.archival.colReference')}</th><th>{t('m19.archival.colStatus')}</th><th>{t('m19.archival.colRecords')}</th></tr></thead>
        <tbody>
          {rows.map((a) => (
            <tr key={a.archivalId}>
              <td>{a.entityType}</td>
              <td>{a.entityReference}</td>
              <td>{a.status}</td>
              <td>{a.recordCount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
